import React, { memo } from 'react';
import { useInstantSearch } from 'react-instantsearch-hooks-web';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';

interface NoSearchResultsFoundProps {
  heading: string;
  body?: string;
}

const NoSearchResultsFound: React.FC<NoSearchResultsFoundProps> = ({
  heading,
  body = undefined,
}) => {
  const {
    results: { query },
  } = useInstantSearch();

  const QUERY_PLACEHOLDER_TEXTS: string[] = [
    '<searched_value>',
    '<searched_value>.',
  ];

  const NoSearchResultsFoundHeading = (props: {
    text: string;
    query: string;
  }): JSX.Element => {
    const words: string[] = props.text.split(' ');
    return (
      <h2 className="text-2xl lg:text-4xl">
        {words.map((word: string, index: number) =>
          QUERY_PLACEHOLDER_TEXTS.includes(word) ? (
            <span className="text-text/body-accent">{`${props.query}${
              word.includes('.') ? '.' : ''
            }}${index < words.length - 1 ? ' ' : ''}`}</span>
          ) : (
            `${word}${index < words.length - 1 ? ' ' : ''}`
          )
        )}
      </h2>
    );
  };

  const NoSearchResultsFoundBody = (props: {
    text: string;
    query: string;
  }): JSX.Element => {
    const words: string[] = props.text.split(' ');
    return (
      <p className="text-text/body-tint">
        {words.map((word: string, index: number) =>
          QUERY_PLACEHOLDER_TEXTS.includes(word) ? (
            <span key={props.query} className="font-bold">{`${props.query}${
              word.includes('.') ? '.' : ''
            }${index < words.length - 1 ? ' ' : ''}`}</span>
          ) : (
            `${word}${index < words.length - 1 ? ' ' : ''}`
          )
        )}
      </p>
    );
  };

  return (
    <div className="py-10 md:py-16 lg:py-20">
      <Container>
        <Grid>
          <Col span={{ md: 10, lg: 8, xl: 6 }} start={{ md: 1, lg: 2, xl: 4 }}>
            <div className="flex items-center justify-center">
              <div className="text-center space-y-4">
                <NoSearchResultsFoundHeading text={heading} query={query} />
                {body && <NoSearchResultsFoundBody text={body} query={query} />}
              </div>
            </div>
          </Col>
        </Grid>
      </Container>
    </div>
  );
};

export default memo(NoSearchResultsFound);
